import * as api from "@/api/williams/welders";
import { Welder } from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function useDeleteWelder() {
  const queryClient = useQueryClient();

  return useMutation(async (welder: Welder) => {
    await api.deleteWelder(welder.welderId);

    queryClient.removeQueries(queryKeys.welder.single(welder.welderId));
    queryClient.invalidateQueries(queryKeys.welder.list());
  });
}
